import React from "react"
import { TextTable } from "../../components/Text"
import { HeaderRow, Row } from "./styled.js"

const Table = ({ data }) => {
  const len = data.length
  const flexBasisStyle = { flexBasis: 100 / data[0].length + "%" }

  return (
    <>
      <HeaderRow>
        {len > 0 &&
          data[0].map(item => (
            <TextTable style={flexBasisStyle}>{item}</TextTable>
          ))}
      </HeaderRow>
      {len > 1 && (
        <RowBuilder rowsNum={len} data={data} style={flexBasisStyle} />
      )}
    </>
  )
}

const RowBuilder = ({ rowsNum, data, style }) => {
  const ReturnArr = []
  for (let i = 1; i < rowsNum; i++) {
    ReturnArr.push(
      <Row>
        {data[i].map(item => (
          <TextTable style={style}>{item}</TextTable>
        ))}
      </Row>
    )
  }
  return ReturnArr
}

export default Table
